<template>
  <transition name="m-fade" appear>
    <div>
      <m-notification />
      <transition name="m-fade">
        <router-view/>
      </transition>
      </div>
  </transition>

</template>

<script>
  import utils from '@/assets/utils/index'
  import MNotification from '@/components/common/MNotification'
  import _ from 'lodash'
  // import jsCookie from 'js-cookie'

  export default {
    name: 'app',
    components: {
      MNotification
    },
    data () {
      return {
        show: false
      }
    },
    created () {
      this.checkLogin()
      if (this.$route.query.ui) {
        this.$store.commit('config/saveKey', ['uiVersion', parseInt(this.$route.query.ui)])
      }
      this.$root.$on('run', () => {
        this.run()
      })
    },
    methods: {
      checkLogin () {
        this.$store.commit('config/setRootUrl', utils.getRootPath())
        document.getElementById('loading-title').style.display = 'none'

        // User has logged in
        //if (window.first.isLogin === 'ok') {
          this.run()
          this.$store.dispatch('user/getUserInit')
          this.$store.dispatch('user/getEditUserInfo')
        // } else {
        //   utils.progressDone()
        //   this.$router.push({name: 'signin'})
        // }
      },
      run () {
        this.getDatasource()
        this.$store.dispatch('site/init')
        this.$store.dispatch('geo/getStates')
      },
      // Using first datasouce
      getDatasource () {
        if (window.first.datasourceStatus === 'loading') {
          setTimeout(this.getDatasource, 10)
          return false
        } else if (window.first.datasourceStatus === 'unLoad') {
          window.first.getDataSource()
          setTimeout(this.getDatasource, 10)
          return false
        }

        let data = window.first.datasource
        let allowDatasources = []
        data.forEach(item => {
          allowDatasources.push(item.ListType)
        })
        this.$store.commit('config/saveKey', ['allowDatasources', allowDatasources])

        // check datasource route
        if (this.$route.path.split('/')[1] === 'order' &&
          !this.$store.getters['config/checkDatasource'](this.$route.params.listType)) {
          this.$router.replace({name: 'landing'})
          this.$notice('warning', 'No this datasource, please choose one')
        }

        // TODO@PONY need to optimal datasource
        data = _.map(data, item => {
          // TODO@PONY it's not good
          if (item.Desc === 'Occupant') {
            item.Desc = 'Saturation'
            item.Sequence = 1
          }
          let datasource = this.$store.state.config.datasource[item.ListType.toString()]
          Object.assign(item, datasource)
          return item
        })
        this.$store.commit('user/saveKey', ['userDataSources', data])

        let serviceData = window.first.serviceDataSource
        this.$store.commit('user/saveKey', ['userServiceDataSources', serviceData])
      }
    }
  }
</script>

<style lang="scss" scoped>



</style>
<style lang="scss">
/*@import "./assets/style/custom.scss";*/

//@import url(./assets/style/insurance.scss);
</style>




// WEBPACK FOOTER //
// src/App.vue